import { Outlet, createFileRoute } from "@tanstack/react-router";

import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/library")({
  loader: () => ({ crumb: m.library_title() }),
  component: Outlet,
});
